import {
  emilia,
  rem,
  aqua,
  asuna,
  darkness,
  ferris,
  haruhi,
  hitagi,
  holo,
  kaori,
  mashiro,
  megumin,
  mio,
  mitsuha,
  ram,
  saber,
  shouko,
  yukino,
  marin,
  zeroTwo,
  chelsea,
  chika,
  chitanda,
  chizuru,
  iino,
  kaguya,
  mai,
  miku,
  nino,
  violet
} from './waifus';

export const animeGirls = [
  { name: 'Emilia', image: emilia },
  { name: 'Rem', image: rem },
  { name: 'Aqua', image: aqua },
  { name: 'Asuna', image: asuna },
  { name: 'Darkness', image: darkness },
  { name: 'Ferris', image: ferris },
  { name: 'Haruhi', image: haruhi },
  { name: 'Hitagi', image: hitagi },
  { name: 'Holo', image: holo },
  { name: 'Kaori', image: kaori },
  { name: 'Mashiro', image: mashiro },
  { name: 'Megumin', image: megumin },
  { name: 'Mio', image: mio },
  { name: 'Mitsuha', image: mitsuha },
  { name: 'Ram', image: ram },
  { name: 'Saber', image: saber },
  { name: 'Shouko', image: shouko },
  { name: 'Yukino', image: yukino },
  { name: 'Marin', image: marin },
  { name: 'Zero Two', image: zeroTwo },
  { name: 'Chelsea', image: chelsea },
  { name: 'Chika', image: chika },
  { name: 'Chitanda', image: chitanda },
  { name: 'Chizuru', image: chizuru },
  { name: 'Iino', image: iino },
  { name: 'Kaguya', image: kaguya },
  { name: 'Mai', image: mai },
  { name: 'Miku', image: miku },
  { name: 'Nino', image: nino },
  { name: 'Violet', image: violet }
].map((animeGirl) => ({ ...animeGirl, isClicked: false }));
